
import axios from 'axios';



class CurrencyService {
    currencies(params) {
        return axios.get("/api/currency", {
            params: params
        })
    }

    currencyCount(params) {
        return axios.get("/api/currency/count", {
            params: params
        })
    }

    currencyRegister(payload) {
        return axios.post("/api/currency/register", payload)
    }

    currencyUpdateRate({id, amount}) {
        return axios.post(`/api/currency/update/${id}`, {
            amount: amount
        })
    }

    currencyConverter(payload) {
        return axios.post(`/api/currency/convert`, {
            payload
        })
    }
}


const currencyService = new CurrencyService()

export default currencyService;